module.exports = __webpack_public_path__ + "static/ssdbot-d89db1164e921bc9013e9919e7015d89.jpg";